import ufeApi from 'services/api/ufeApi';
import localeUtils from 'utils/LanguageLocale';
import { CONTENT_EXPERIENCE_PATH, CONTENT_CHANNEL, getPartnerSlug } from 'components/LoyaltyConnection/constants';

/**
 * Fetches the partner loyalty page content from the content-page-exp CMS via the
 * same-origin `/api/content` proxy (LC-145). `loc` is derived from the active
 * locale (e.g. en-US / fr-CA) the same way other content APIs do; the partner
 * slug is taken from the page URL.
 *
 * @returns {Promise<Object>} Raw CMS payload ({ data: { contentSections: [...] } }).
 */
async function getPartnerContent() {
    const loc = localeUtils.getCurrentLanguageLocale();
    const url = `${CONTENT_EXPERIENCE_PATH}/${getPartnerSlug()}?loc=${loc}&ch=${CONTENT_CHANNEL}`;

    const data = await ufeApi.makeRequest(url, { method: 'GET' });

    if (data && data.errorCode) {
        throw data;
    }

    return data;
}

export default getPartnerContent;
